export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SCROLL_TO_TOP = 'SCROLL_TO_TOP';
export const SCROLL_TO_ERRORS = 'SCROLL_TO_ERRORS';

export const CONTEXT_TYPE = {
    FULL_CONTEXT: 'Full-context',
    IN_CONTEXT: 'In-context',
    MB_CONTEXT: 'Mb-context',
    MOCK: 'Mock-context'
};
